'use client';
import dynamic from 'next/dynamic';
import type { LottieComponentProps } from 'lottie-react';

// Dynamically import Lottie with SSR disabled to avoid document is not defined error
const LottieComponent = dynamic(() => import('lottie-react'), {
  ssr: false,
});

// Re-export types for easy migration
export type { LottieComponentProps, LottieRefCurrentProps } from 'lottie-react';
export type LottieWrapperProps = LottieComponentProps;

// Default export for component usage
export default function LottieWrapper(props: LottieWrapperProps) {
  return <LottieComponent {...props} />;
}

// Named export for easier migration from 'import Lottie from ...'
export const Lottie = LottieWrapper;
